import { Component } from '@angular/core';
import { CommonService } from 'src/services/common/common.service';

@Component({
  selector: 'app-become-a-peer-support',
  templateUrl: './become-a-peer-support.component.html',
  styleUrls: ['./become-a-peer-support.component.scss']
})
export class BecomeAPeerSupportComponent {
  constructor(public commonService: CommonService) {}
}
